export default {
    contentModule: {
        display: 'grid',
        gridTemplateColumns: '65% 35%',
    },
    extended: {
        gridTemplateColumns: '100%'
    },
    contentModuleRowReverse: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        '& $contentModuleCell': {
            textAlign: 'end',
        },
        '& contentModuleCellPrice': {
            textAlign: 'end',
        }
    },
    addPadding: {
        paddingTop: '2px'
    },
    addPaddingLarge: {
        paddingTop: '4px',
    },
    contentModuleCellTitle: {
        font: "400 16px 'Roboto', sans-serif",
        color: '#666666'
    },
    contentModuleCellPrice: {
        font: "400 16px 'Roboto', sans-serif",
        color: '#666666',
        textAlign: 'right',
        '&:lang(ar)': {
            textAlign: "left"
        }
    },
}